import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { GradeApi } from 'api';
import type { Grade } from 'api/methods/GradeApi';

/**
 * [Grade] Query key 생성
 * --
 */
export const gradeQueryKeys = createQueryKeys('grade', {
  getGrade: (idx: number, params?: { [key: string]: string | number }) => [
    idx,
    params,
  ],
  getGrades: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [Grade] 등급 전체 조회
 * --
 */
export const useGetGrades = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: gradeQueryKeys.getGrades(params).queryKey,
    queryFn: () => GradeApi.getGrades(params),
    ...options,
  });
  return data;
};

/**
 * [Grade] 등급 상세 조회
 * --
 */
export const useGetGrade = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: gradeQueryKeys.getGrade(idx, params).queryKey,
    queryFn: () => GradeApi.getGrade(idx, params),
  });

  return data;
};

/**
 * [Grade] 등급 생성
 * --
 */
export const useCreateGrade = (body: Grade) => {
  const { mutateAsync: createGrade, ...result } = useMutation({
    mutationFn: (variables: Grade) => GradeApi.createGrade(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createGrade, ...result };
};

/**
 * [Grade] 등급 수정
 * --
 */
export const useUpdateGrade = (body: Grade) => {
  const { mutateAsync: updateGrade, ...result } = useMutation({
    mutationFn: (variables: Grade) => GradeApi.updateGrade(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateGrade, ...result };
};

/**
 * [Grade] 등급 삭제
 * --
 */
export const useDeleteGrade = (idx: number) => {
  const { mutateAsync: deleteGrade, ...result } = useMutation({
    mutationFn: (variables: number) => GradeApi.deleteGrade(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteGrade, ...result };
};
